"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayoff_types_1 = require("./dayoff.types");
const dayoff_1 = require("services/adjustment/dayoff");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dayoff_1._getGridDayOff)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { date_off: new Date(item.date_off), created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_DATA_GRID, payload: payload });
    }
});
const getDataCalendar = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dayoff_1._getCalendarDayOff)();
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            dataCalendar: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { id: item.id, isAllDay: true, recurrenceRule: '', event: item.event_day, start: new Date(item.date_off), end: new Date(new Date(item.date_off).getTime() + 60 * 60 * 1000) });
            })
        };
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_DATA_CALENDAR, payload: payload });
    }
});
const syncDataDayOff = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dayoff_1._syncDataDayOff)();
    if (response.isError) {
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SYNC_DATA_CALENDAR, payload: response });
    }
});
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const arg = {
        date_off: dataItem.date_off,
        event_day: dataItem.event_day
    };
    if (mutationMode === 'edit')
        arg.id = dataItem.id;
    const response = mutationMode === 'add'
        ? yield (0, dayoff_1._postDataDayOff)(arg)
        : yield (0, dayoff_1._putDataDayOff)(arg);
    if (response.isError) {
        dispatch({
            type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: dayoff_types_1.adjustmentDayOffTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: !response.isError
            }
        });
    }
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, dayoff_1._deleteBrandData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: dayoff_types_1.adjustmentDayOffTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: !response.isError
            }
        });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: dayoff_types_1.adjustmentDayOffTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onLoading = () => dispatch => {
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.SET_LOADING, payload: true });
};
const onSyncData = () => dispatch => {
    dispatch({ type: dayoff_types_1.adjustmentDayOffTypes.ON_SYNC_DATA, payload: true });
};
exports.default = {
    onLoading,
    onSyncData,
    getDataGrid,
    onSortChange,
    onCloseError,
    onFilterChange,
    onSaveDataItem,
    syncDataDayOff,
    onClickMutation,
    getDataCalendar,
    onDeleteDataItem,
    onDataStateChange,
};
